import { CommonModule } from "@angular/common";
import { Component } from "@angular/core";

import { PremiumBadgeComponent } from "@bitwarden/angular/billing/components/premium-badge";
import { ButtonModule, CalloutModule, IconButtonModule, IconModule } from "@bitwarden/components";
import { I18nPipe } from "@bitwarden/ui-common";

import { TwoFactorSetupComponent } from "../two-factor/two-factor-setup.component";

import { BvTwoFactorProviderIconComponent } from "./bv-two-factor-provider-icon.component";

// FIXME(https://bitwarden.atlassian.net/browse/CL-764): Migrate to OnPush
// eslint-disable-next-line @angular-eslint/prefer-on-push-component-change-detection
@Component({
  selector: "app-web-two-factor-setup",
  templateUrl: "./web-two-factor-setup.component.html",
  host: {
    class: "bv-security-two-factor-host",
  },
  imports: [
    BvTwoFactorProviderIconComponent,
    ButtonModule,
    CalloutModule,
    CommonModule,
    IconButtonModule,
    IconModule,
    I18nPipe,
    PremiumBadgeComponent,
  ],
})
export class WebTwoFactorSetupComponent extends TwoFactorSetupComponent {
  showRecoveryWarning = true;
}
